import Auth, { FetchAPI, Mutex } from './auth-service';

const LogFields = [
    {
        variable: 'created',
        hidden: false,
        hiddenByColumnsButton: true,
        title: 'Time',
        field: 'created',
        defaultSort: 'desc',
        type: 'str',
        flexDefault: 0.5,
    },
    {
        variable: 'host',
        hidden: false,
        hiddenByColumnsButton: true,
        title: 'Host',
        field: 'data.host',
        type: 'str',
        flexDefault: 0.5,
    },
    {
        variable: 'actor',
        hidden: false,
        hiddenByColumnsButton: true,
        title: 'User',
        field: 'data.actor',
        type: 'str',
        flexDefault: 0.5,
    },
    {
        variable: 'action',
        hidden: false,
        hiddenByColumnsButton: true,
        title: 'Action',
        field: 'data.action',
        type: 'str',
        flexDefault: 3,
        cellStyle: {
            textOverflow: 'ellipsis',
            whitespace: 'nowrap',
            overflow: 'hidden',
            maxWidth: 200,
        },
    },
    {
        variable: 'result',
        hidden: false,
        hiddenByColumnsButton: true,
        title: 'Result',
        field: 'result',
        type: 'str',
        flexDefault: 0.25,
    },
];

const isItEmpty = (r) => {
    if (!r.data.tags) r.data.tags = [];
    if (!r.data.metadata) r.data.metadata = [];
    if (!r.data.alerts) r.data.alerts = [];
    if (!r.data.notes) r.data.notes = [];
    if (!r.data.files) r.data.files = [];
    if (!r.data.logs) r.data.logs = [];
    if (!r.data.mitigations) r.data.mitigations = { internal: [], external: [] };

    return r;
};

class IncidentDataService {
    constructor () {
        if (!IncidentDataService.instance) {
            IncidentDataService.instance = this;
            this.catMux = new Mutex();
        }
        this.searchPlaceholder = 'Search...';

        this.get = (uuid) => {
            return FetchAPI({
                method: 'GET',
                url: `incidents/${uuid}/`,
            }).then(res => {
                if (!res) res = { data: {} };
                return isItEmpty(res);
            });
        };

        this.getAll = () => {
            return FetchAPI({
                method: 'GET',
                url: 'incidents/',
            }).then(res => {
                if (!res) res = [];
                res = res.map((v) => {
                    return isItEmpty(v);
                });

                return res;
            });
        };

        this.getNames = () => {
            return FetchAPI({
                method: 'GET',
                url: 'incidents/incidentnames',
            });
        };

        this.create = (data) => {
            return FetchAPI({
                method: 'POST',
                url: 'incidents/',
                body: data,
            });
        };

        this.update = (uuid, data) => {
            return FetchAPI({
                method: 'PUT',
                url: `incidents/${uuid}/`,
                body: data,
            }).then(res => {
                if (!res) res = { data: {} };
                return isItEmpty(res);
            });
        };

        this.delete = (uuid) => {
            return FetchAPI({
                method: 'DELETE',
                url: `incidents/${uuid}/`,
            });
        };

        this.resolve = (uuid) => {
            return FetchAPI({
                method: 'PUT',
                url: `incidents/${uuid}/-resolve`,
            }).then(res => {
                if (!res) res = { data: {} };
                return isItEmpty(res);
            });
        };

        this.open = (uuid) => {
            return FetchAPI({
                method: 'PUT',
                url: `incidents/${uuid}/-open`,
            }).then(res => {
                if (!res) res = { data: {} };
                return isItEmpty(res);
            });
        };

        this.addData = (uuid, data) => {
            return FetchAPI({
                method: 'PUT',
                url: `incidents/${uuid}/data/`,
                body: data,
            }).then(res => {
                if (!res) res = { data: {} };
                return isItEmpty(res);
            });
        };

        this.removeData = (uuid, data) => {
            return FetchAPI({
                method: 'DELETE',
                url: `incidents/${uuid}/data/`,
                body: data,
            }).then(res => {
                if (!res) res = { data: {} };
                return isItEmpty(res);
            });
        };

        this.addMetadata = (uuid, mtdts) => {
            return FetchAPI({
                method: 'POST',
                url: `incidents/${uuid}/metadata/`,
                body: mtdts,
            }).then(res => {
                if (!res) res = { data: {} };
                return isItEmpty(res);
            });
        };

        this.addAlerts = (uuid, alerts) => {
            return FetchAPI({
                method: 'POST',
                url: `incidents/${uuid}/alert/`,
                body: alerts,
            }).then(res => {
                if (!res) res = { data: {} };
                return isItEmpty(res);
            });
        };

        this.removeMetadata = (uuid, mtdt) => {
            return FetchAPI({
                method: 'DELETE',
                url: `incidents/${uuid}/metadata/${mtdt}`,
            }).then(res => {
                if (!res) res = { data: {} };
                return isItEmpty(res);
            });
        };

        this.removeAlert = (uuid, alert) => {
            return FetchAPI({
                method: 'DELETE',
                url: `incidents/${uuid}/alert/${alert}`,
            }).then(res => {
                if (!res) res = { data: {} };
                return isItEmpty(res);
            });
        };

        this.uploadFile = (uuid, content, details, progressCB, stateCB) => {
            const a = Auth.getAuth();
            const form = new FormData();
            form.append('fileblob', content);
            form.append('timestamp', details.timestamp);
            form.append('description', details.description);
            form.append('mitigation', details.mitigation);

            const r = new XMLHttpRequest();
            r.upload.addEventListener('progress', progressCB);

            r.open('PUT', `/api/incidents/${uuid}/file/`);
            r.setRequestHeader('Authorization', `Bearer ${a.token}`);
            r.timeout = 45000;
            r.onreadystatechange = () => stateCB(r);
            r.send(form);

            // return fetch(`api/incidents/${uuid}/file/`, {
            //     method: 'PUT',
            //     headers: {
            //         Authorization: `Bearer ${a.token}`,
            //     },
            //     body: form,
            // }).then((response) => {
            //     return response.text().then(text => {
            //         let data = text;
            //         try {
            //             data = text && JSON.parse(text);
            //         } catch (err) {
            //             // response isn't json
            //             if ((text || '').trim() !== 'null') {
            //                 data = text;
            //             }
            //         }
            //         if (!response.ok) {
            //             const error = data || response;
            //             return Promise.reject(error);
            //         }

            //         return isItEmpty(data);
            //     });
            // }).catch(error => {
            //     if ([401, 403].indexOf(error.status) !== -1) {
            //         return Auth.boot();
            //     }
            //     return Promise.reject(error);
            // });
        };

        this.downloadFile = (uuid, filename) => {
            const a = Auth.getAuth();

            return fetch(`api/incidents/${uuid}/file/${filename}`, {
                method: 'GET',
                headers: {
                    Authorization: `Bearer ${a.token}`,
                }
            }).then((response) => {
                return response.blob().then(blob => {
                    if (!response.ok) {
                        return Promise.reject(response);
                    }
                    return blob;
                });
            }).catch(error => {
                if ([401, 403].indexOf(error.status) !== -1) {
                    return Auth.boot();
                }
                return Promise.reject(error);
            });
        };

        // this.downloadFile = (uuid, filename) => {
        //     return FetchAPI({
        //         method: 'GET',
        //         url: `incidents/${uuid}/file/${filename}`,
        //     });
        // };

        this.deleteFile = (uuid, filename) => {
            return FetchAPI({
                method: 'DELETE',
                url: `incidents/${uuid}/file/${filename}`,
            });
        };

        this.getLogs = (uuid) => {
            return FetchAPI({
                method: 'GET',
                url: `incidents/${uuid}/logs/`,
            });
        };

        this.getAlerts = (uuid) => {
            return FetchAPI({
                method: 'GET',
                url: `incidents/${uuid}/alerts/`,
            });
        };

        this.getMetadata = (uuid) => {
            return FetchAPI({
                method: 'GET',
                url: `incidents/${uuid}/metadata/`,
            });
        };

        // only want to call this guys once, without calling a bunch of times all at once
        this.getMitreCategories = async () => {
            const unlock = await this.catMux.lock();
            if (this.categories) {
                unlock();
                return Promise.resolve(this.categories);
            }
            return FetchAPI({
                method: 'GET',
                url: 'incidents/mitre/categories/',
            }).then(res => {
                this.categories = res;
                this.categoriesMap = (res || [])
                    .reduce((a, c, i) => ({ ...a, [c.id]: { ...c, order: i } }), {});
                return this.categories;
            }).finally(() => unlock());
        };
        this.getMitreCategoriesMap = async () => {
            const unlock = await this.catMux.lock();
            if (this.categoriesMap) {
                unlock();
                return Promise.resolve(this.categoriesMap);
            }
            return FetchAPI({
                method: 'GET',
                url: 'incidents/mitre/categories/',
            }).then(res => {
                this.categories = res;
                this.categoriesMap = (res || [])
                    .reduce((a, c, i) => ({ ...a, [c.id]: { ...c, order: i } }), {});
                return this.categoriesMap;
            }).finally(() => unlock());
        };

        return IncidentDataService.instance;
    }
}

const IncidentService = new IncidentDataService();

export {
    IncidentService as default,
    LogFields,
};
